import { replace, toUpper } from 'ramda'

const Capitalize = replace(/^./, toUpper)

export default Capitalize



// WEBPACK FOOTER //
// ./src/Lib/Capitalize.js